import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { LEGAL_PAGES } from "../../core/constants/legal.constants";
import { SeoService } from "../../core/services/seo.service";
import { APP_NAME, APP_CONSTANTS } from "../../core/constants/app.constants";

@Component({
  selector: "app-info-page",
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./info-page.component.html",
  styleUrl: "./info-page.component.scss",
})
export class InfoPageComponent {
  readonly appName = APP_NAME;
  readonly page =
    LEGAL_PAGES[inject(ActivatedRoute).snapshot.routeConfig?.path ?? ""];

  constructor() {
    if (!this.page) return;
    inject(SeoService).updatePage({
      title: `${this.page.title} | ${APP_NAME}`,
      description: this.page.description,
      canonical: `${APP_CONSTANTS.siteUrl}/${this.page.slug}/`,
    });
  }
}
